import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	coreSonarTasksByOrganizationIdAndTaskTypeReducers,
	coreSonarTasksByOrganizationIdAndTaskTypeWatchers
} from './_taskType';

export const coreSonarTasksByOrganizationIdReducers = combineReducers({
	types: coreSonarTasksByOrganizationIdAndTaskTypeReducers
});

export const coreSonarTasksByOrganizationIdWatchers = combineAllWatchers([
	coreSonarTasksByOrganizationIdAndTaskTypeWatchers
]);
